import { render, staticRenderFns } from "./ProductsTableComponent.vue?vue&type=template&id=02c6ffee&scoped=true"
import script from "./ProductsTableComponent.vue?vue&type=script&lang=js"
export * from "./ProductsTableComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductsTableComponent.vue?vue&type=style&index=0&id=02c6ffee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c6ffee",
  null
  
)

export default component.exports